export const MATOMO_URL = "https://gatibidhi.shekhar.net.np"
export const MATOMO_SITE_ID = "4"

export const EVENT_SCHEMA_VERSION = 1 as const

export const ANALYTICS_ENABLED =
  process.env.NODE_ENV === "production" && process.env.NEXT_PUBLIC_ENABLE_ANALYTICS === "true"

export const ANALYTICS_DEFAULTS = {
  userTier: "FREE",
  workspaceId: "personal",
} as const

export const ANALYTICS_WORKSPACE_STORAGE_KEY = "thp_analytics_workspace_id"
